module.exports = __webpack_public_path__ + "static/media/lock-open-alt.2004809f.svg";